export default "__VITE_ASSET__bxtAezq7__"